module.exports = __webpack_public_path__ + "img/rod_05.5bdb0041.svg";